<div class="footer container-fluid">
  <div class="row text-center footer-content">

    <!-- Lexus Footer -->
    <div *ngIf="appName === 'lexus'" class="col-sm-12 align-self-center">
      <div class="col-sm-12 align-self-center">
        <ng-container *ngFor="let link of lexusPrivacyLink; let i = index">
          <ng-container *ngIf="link.privacyLinkName === 'COOKIE CONSENT OPTIONS'; else normalLexusLink">
            <a href="javascript:void(0)" (click)="openCookieConsentModal()">{{ link.privacyLinkName }}</a>
          </ng-container>
          <ng-template #normalLexusLink>
            <a [href]="link.privacyLinkUrl" target="_blank" rel="noopener noreferrer">{{ link.privacyLinkName }}</a>
          </ng-template>

          <span class="btn-img" aria-hidden="true" *ngIf="link.privacyLinkName === 'YOUR PRIVACY CHOICES'">
            <img src="/assets/images/common/privacyCheckmark.png" alt="YOUR PRIVACY CHOICES" role="presentation" />
          </span>

          <span *ngIf="i !== lexusPrivacyLink.length - 1"> | </span>
        </ng-container>
      </div>
      <div class="mt-2 col-sm-12 align-self-center privacyPolicy">
        {{ "Label.footer_lexus_content" | translate }}
      </div>
    </div>

    <!-- Toyota Footer -->
    <div *ngIf="appName === 'toyota'" class="col-sm-12 align-self-center">
      <div class="col-sm-12 align-self-center">
        <ng-container *ngFor="let link of toyotaPrivacyLink; let i = index">
          <ng-container *ngIf="link.privacyLinkName === 'Cookie Consent Options'; else normalToyotaLink">
            <a href="javascript:void(0)" (click)="openCookieConsentModal()">{{ link.privacyLinkName }}</a>
          </ng-container>
          <ng-template #normalToyotaLink>
            <a [href]="link.privacyLinkUrl" target="_blank" rel="noopener noreferrer">{{ link.privacyLinkName }}</a>
          </ng-template>

          <span class="btn-img" aria-hidden="true" *ngIf="link.privacyLinkName === 'YOUR PRIVACY CHOICES'">
            <img src="/assets/images/common/privacyCheckmark.png" alt="YOUR PRIVACY CHOICES" role="presentation" />
          </span>

          <span *ngIf="i !== toyotaPrivacyLink.length - 1"> | </span>
        </ng-container>
      </div>
      <div class="mt-2 col-sm-12 align-self-center privacyPolicy">
        {{ "Label.footer_toyota_content" | translate }}
      </div>
    </div>

  </div>
</div>